import styled from 'styled-components';
import { Table, Form, Row, Col, InputGroup } from 'react-bootstrap';
import { ToReadableDate, ToCurrencyFormat } from '../../../utils';

const TableContainer = styled.div`
    overflow-x: auto;
    white-space: nowrap;
    padding: 0;
    margin: 0;
    width: 100%;
`;

const Title = styled.h1`
    font-size: 36px;
    font-weight: 700;
`;

export default function ShowDetails({ formData, setFormData }) {
    return (
        <div>
            <br />

            <Row>
                <Title>Claim Details</Title>
            </Row>
            <Row>
                <Col lg={12}>
                    <Form.Group>
                        <Form.Label>1. Incident Report (What, When, How)</Form.Label>
                        <InputGroup>
                            <Form.Control
                                as="textarea"
                                rows={2}
                                value={formData?.claimsPayload?.incidentDetails || ''}
                                aria-label="With textarea"
                                readOnly
                            />
                        </InputGroup>
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col lg={4}>
                    <Form.Group>
                        <Form.Label className="pt-2">2. Location of Incident:</Form.Label>
                        <Form.Control type="text" value={formData?.claimsPayload?.incidentLocation || ''} readOnly />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col lg={4}>
                    <Form.Group>
                        <Form.Label className="pt-2">3. Date of Incident:</Form.Label>
                        <Form.Control
                            type="text"
                            value={
                                formData?.claimsPayload?.incidentDate
                                    ? ToReadableDate(formData.claimsPayload.incidentDate)
                                    : ''
                            }
                            readOnly
                        />
                    </Form.Group>
                </Col>
            </Row>

            <Row className="pt-2">
                <Form.Label>4. List of Damaged Items:</Form.Label>
            </Row>

            <TableContainer>
                <Table bordered hover>
                    <thead className="text-center">
                        <tr>
                            <th>Damaged Items</th>
                            <th>Brand</th>
                            <th>Product Specification</th>
                            <th>Year Purchased</th>
                            <th>Amount Purchased</th>
                            <th>Remarks</th>
                        </tr>
                    </thead>
                    <tbody className="text-center">
                        {formData?.claimsPayload?.claimItems && formData?.claimsPayload?.claimItems.length > 0 ? (
                            formData?.claimsPayload?.claimItems.map((item, index) => (
                                <tr key={'claimItem_' + index}>
                                    <td>{item.item}</td>
                                    <td>{item.brand}</td>
                                    <td>{item.specification}</td>
                                    <td>{item.purchaseYear}</td>
                                    <td>{item.purchaseAmount ? `₱${item.purchaseAmount.toLocaleString()}` : 'N/A'}</td>
                                    <td>
                                        <Form.Control
                                            type="text"
                                            value={item.remarks}
                                            onChange={(e) => {
                                                const updatedItems = [...formData.claimsPayload.claimItems];
                                                updatedItems[index].remarks = e.target.value;
                                                setFormData({
                                                    ...formData,
                                                    claimsPayload: {
                                                        ...formData.claimsPayload,
                                                        claimItems: updatedItems
                                                    }
                                                });
                                            }}
                                        />
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr className="text-center">
                                <td colSpan="7">No claim items available.</td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </TableContainer>
        </div>
    );
}
